<div class="form configuration-sidebar">

    <div class="configuration-sidebar__header">
        <h2>Preview Self-scheduling Configuration</h2>
    </div>

    <div class="configuration-sidebar__content">
        <div class="form__group full-width">
            <label for="" class="form__label">Configuration Name</label>
            {{config?.name}}
        </div>

        <div class="form__group full-width">
            <label for="" class="form__label">Description</label>
            <span class="description">{{config?.description}}</span>
        </div>

        <div class="col">
            <div class="form__group full-width" >
                <label for="" class="form__label">Branch</label>
                <ng-container *ngIf="branchLabel | viewMore as result">
                    {{result.textResult }}
                    <ng-container *ngIf="result.count>0">
                      <span class="view-more" pTooltip="{{branchLabel}}">+ {{result.count}}  More</span>
                    </ng-container>
                  </ng-container>

            </div>
            <div class="form__group full-width" style="padding: 0rem 1rem;">
                <label for="" class="form__label">Classification</label>
                <ng-container *ngIf="classificationLabel | viewMore as result">
                    {{result.textResult }}
                    <ng-container *ngIf="result.count>0">
                      <span class="view-more" pTooltip="{{classificationLabel}}">+ {{result.count}}  More</span>
                    </ng-container>
                  </ng-container>
            </div>

            <div class="form__group full-width" style="padding: 0rem 1rem;">
                <label for="" class="form__label">Insurance</label>
                <ng-container *ngIf="insuranceLabel | viewMore as result">
                    {{result.textResult }}
                    <ng-container *ngIf="result.count>0">
                      <span class="view-more" pTooltip="{{insuranceLabel}}">+ {{result.count}}  More</span>
                    </ng-container>
                  </ng-container>
            </div>
        </div>

        <div class="preview-expected-result">
            <h3>Expected Result</h3>

            <div class="form__group full-width">
                <label for="" class="form__label">Appointment invitation template</label>
                {{templateLabel}}
            </div>

            <div class="preview-btns">
                <a (click)="EmailPreviewClick()" class="btn btn--primary">
                    <svg width="20" height="15" viewBox="0 0 20 15" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path
                            d="M12.5627 7.30533C12.5627 8.83288 11.3243 10.0711 9.79685 10.0711C8.2693 10.0711 7.03101 8.83288 7.03101 7.30533C7.03101 5.77777 8.2693 4.53952 9.79685 4.53952C11.3243 4.53952 12.5627 5.77777 12.5627 7.30533Z"
                            stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                        <path
                            d="M1 7.3053C2.1748 3.56489 5.6692 0.851746 9.79729 0.851746C13.9254 0.851746 17.4198 3.56492 18.5946 7.3053C17.4198 11.0457 13.9254 13.7589 9.79729 13.7589C5.66919 13.7589 2.17478 11.0457 1 7.3053Z"
                            stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                    </svg>
                    Preview Email
                </a>
                <a (click)="SMSPreviewClick()" class="btn btn--primary">
                    <svg width="20" height="15" viewBox="0 0 20 15" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path
                            d="M12.5627 7.30533C12.5627 8.83288 11.3243 10.0711 9.79685 10.0711C8.2693 10.0711 7.03101 8.83288 7.03101 7.30533C7.03101 5.77777 8.2693 4.53952 9.79685 4.53952C11.3243 4.53952 12.5627 5.77777 12.5627 7.30533Z"
                            stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                        <path
                            d="M1 7.3053C2.1748 3.56489 5.6692 0.851746 9.79729 0.851746C13.9254 0.851746 17.4198 3.56492 18.5946 7.3053C17.4198 11.0457 13.9254 13.7589 9.79729 13.7589C5.66919 13.7589 2.17478 11.0457 1 7.3053Z"
                            stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                    </svg>
                    Preview SMS
                </a>
            </div>


            <div class="form__group full-width">
                <label for="" class="form__label">Default appointment options for Fresh appointments</label>
                <div *ngIf="config?.jsonValue?.isFreshRemoteTypeAppointment"> Remote <span>(Online
                        Appointment)</span>,</div>
                <div *ngIf="config?.jsonValue?.isFreshFacilityTypeAppointment">Facility <span>(Clinic
                        Visit)</span> </div>
            </div>

            <div class="col">
                <div class="col__left" *ngIf="config?.jsonValue?.isCancellationAllowed">
                    <div class="form__group full-width">
                        <label for="" class="form__label">Cancel appointment</label>
                        {{ config?.jsonValue?.isLimitNoOfCancelAppointments ? 'No. of attempts (fixed): ' +
                        config?.jsonValue?.maxCancelAllowed : 'Unlimited' }}
                    </div>
                </div>
                <div class="col__right">
                    <div class="form__group full-width" *ngIf="config?.jsonValue?.isRescheduleAllowed">
                        <label for="" class="form__label">Reschedule appointment</label>
                        {{ config?.jsonValue?.isLimitNoOfRescheduleAppointments ? 'No. of attempts (fixed): ' +
                        config?.jsonValue?.maxRescheduleAllowed : 'Unlimited' }}
                    </div>
                    <div class="form__group full-width">
                        <label for="" class="form__label">Default appointment options while rescheduling</label>
                        <div *ngIf="config?.jsonValue?.isRescheduleRemoteAppointmentType"> Remote <span>(Online
                                Appointment)</span>,</div>
                        <div *ngIf="config?.jsonValue?.isRescheduleFacilityAppointmentType">Facility
                            <span>(Clinic Visit)</span>
                        </div>
                    </div>
                </div>


            </div>


        </div>

    </div>
</div>